module.exports = __webpack_public_path__ + "static/Trello_mini-b0557342f2d15ed7e5dd3114ef109870.svg";